import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt", "disabled"]

import { computed } from 'vue';

    interface Props {
        name?: string;
        color?: string;
        size?: 'x-small' | 'small' | 'default' | 'large' | 'x-large' | number;
        disabled?: boolean;
        clickable?: boolean;
        class?: string | Record<string, boolean> | Array<string | Record<string, boolean>>;
        isCustomImg?: boolean;
        alt?: string;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'AQIcon',
  props: {
    name: {},
    color: { default: 'inherit' },
    size: { default: 'default' },
    disabled: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    class: { default: '' },
    isCustomImg: { type: Boolean, default: false },
    alt: { default: '' }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const iconClass = computed(() => props.class);

    const computedSizeForImg = computed(() => {
        if (!props.size) return undefined;

        const sizeMap: Record<string, string> = {
            'x-small': '12px',
            'small': '16px',
            'default': '24px',
            'large': '32px',
            'x-large': '40px',
        };

        if (typeof props.size === 'string' && sizeMap[props.size]) {
            return sizeMap[props.size];
        }

        return typeof props.size === 'number' ? `${props.size}px` : props.size;
    });

    const handleClick = (event: Event) => {
        if (!props.disabled) {
            emit('click', event);
        }
    };

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (!__props.isCustomImg)
    ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, _ctx.$attrs, {
        icon: __props.name,
        color: __props.color,
        size: __props.size,
        disabled: __props.disabled,
        class: [iconClass.value, { 'cursor-pointer': __props.clickable, 'v-icon--clickable': __props.clickable }],
        onClick: handleClick
      }), null, 16, ["icon", "color", "size", "disabled", "class"]))
    : (_openBlock(), _createElementBlock("img", _mergeProps({
        key: 1,
        src: __props.name,
        alt: __props.alt,
        style: { width: computedSizeForImg.value, height: computedSizeForImg.value, color: __props.color },
        disabled: __props.disabled,
        class: [iconClass.value, { 'cursor-pointer': __props.clickable, 'v-icon--clickable': __props.clickable }]
      }, _ctx.$attrs, { onClick: handleClick }), null, 16, _hoisted_1))
}
}

})